import { startOfDay } from 'date-fns';
import { type Matcher } from 'react-day-picker';

import { type DateFormatConfig, type DateFormatOption } from './types';

export const DATE_FORMATS: Record<DateFormatOption, DateFormatConfig> = {
  iso: {
    pattern: 'yyyy/MM/dd',
    placeholder: 'YYYY/MM/DD',
    label: 'Year/Month/Day',
  },
  mdy: {
    pattern: 'MM/dd/yyyy',
    placeholder: 'MM/DD/YYYY',
    label: 'Month/Day/Year',
  },
  dmy: {
    pattern: 'dd/MM/yyyy',
    placeholder: 'DD/MM/YYYY',
    label: 'Day/Month/Year',
  },
};

export const getBrowserTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * Checks if a date is disabled based on the disabled matcher(s)
 */
export const isDateDisabled = (
  date: Date,
  disabled?: Matcher | Matcher[],
): boolean => {
  if (!disabled) return false;

  const matchers = Array.isArray(disabled) ? disabled : [disabled];

  return matchers.some((matcher) => {
    if (typeof matcher === 'boolean') return matcher;
    if (typeof matcher === 'function') return matcher(date);
    if (matcher instanceof Date) {
      return startOfDay(date).getTime() === startOfDay(matcher).getTime();
    }
    // Handle { before: Date } matcher
    if (typeof matcher === 'object' && 'before' in matcher) {
      const beforeDate = (matcher as { before: Date }).before;
      return startOfDay(date).getTime() < startOfDay(beforeDate).getTime();
    }
    // Handle { after: Date } matcher
    if (typeof matcher === 'object' && 'after' in matcher) {
      const afterDate = (matcher as { after: Date }).after;
      return startOfDay(date).getTime() > startOfDay(afterDate).getTime();
    }
    return false;
  });
};
